var _defs, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew213({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.5,13.28a7.5,7.5,0,0,0-15,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8,
    y1: 2.72,
    x2: 8,
    y2: 5.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew213);
export default __webpack_public_path__ + "static/media/Symbolpack_New_213.bfd33808cf4e5ac8dd922751914bb37b.svg";
export { ForwardRef as ReactComponent };